import request from '@/utils/request'

export function getHotModels() {
  return request({
    url: '/api/home/hot',
    method: 'get'
  })
}

export function getLatestModels() {
  return request({
    url: '/api/home/latest',
    method: 'get'
  })
}

export function getForumLatest() {
  return request({
    url: '/api/home/forum-latest',
    method: 'get'
  })
}